@import 'apps/webcomponents/src/assets/common.scss';

.loaders-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    border-radius: var(--widget-border-radius);
    border: 1px solid var(--chart-101-pressed-dividers);
    margin-bottom: calc(2 * var(--spacer));
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 0 calc(3 * var(--spacer));

    .dashboard-loader {
      height: fit-content;
    }

    .item-content {
      height: 100%;
      &:not(:last-of-type) {
        border-right: 1px solid var(--chart-101-pressed-dividers);
      }
    }

    .content-wrapper {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
    }

    &.column-4,
    &.column-2 {
      .content-wrapper {
        .item-content {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    &.column-4 {
      .content-wrapper {
        flex-direction: row;
        padding-top: calc(3 * var(--spacer));
        padding-bottom: calc(3 * var(--spacer));
        .item-content {
          width: 25%;
          .dashboard-loader {
            width: 60%;
          }
        }
      }
    }

    &.column-2 {
      .content-wrapper {
        flex-direction: row;
        padding-top: calc(1.5 * var(--spacer));
        padding-bottom: calc(1.5 * var(--spacer));

        .item-content:first-of-type {
          width: 65%;
          justify-content: flex-start;
          padding-right: calc(4 * var(--spacer));
        }
        .item-content:last-of-type {
          width: 35%;
          justify-content: flex-end;
          padding-left: calc(4 * var(--spacer));
        }
      }
    }
  }
}

.height-2 {
  height: 68px;
}

.height-3 {
  height: 110px;
}

.height-7 {
  height: 278px;
}

.width-12 {
  width: 100%;
}

.width-8 {
  width: calc(66.66% - var(--spacer));
}

.width-4 {
  width: calc(33.33% - var(--spacer));
}
